import createReducer from 'Rentlio/state/utils/createReducer'

const initialState = false

const isRentlioPayFeatureFlagEnabled = createReducer(initialState)({})

export default isRentlioPayFeatureFlagEnabled
